import Logo from '../assets/logo-header.svg';
import LogoMobile from '../assets/rebrand/footer-rebrand-horizontal.svg';
import LogoDesktop from '../assets/rebrand/footer-rebrand-vertical.svg';

export const rbrHeaderModel = {
  srcHeader: Logo,
  altHeader: 'Logo Rimac',
  title: 'Seguro Salud Flexible',
  telephone: '(01) 411 6001',
};

export const rbrFooterModel = {
  logoMobile: LogoMobile,
  logoDesktop: LogoDesktop,
  altFooter: 'Logo Footer',
  address: 'Calle Las Begonias 650 Piso 10, San Isidro.',
  txtFooter: '© [year] RIMAC Seguros y Reaseguros.',
};
